/**
 * Formata o valor de um campo para CPF ou CNPJ conforme o tamanho dos dígitos.
 *
 * Quando o valor contém até 11 dígitos, ele é formatado como CPF no formato "000.000.000-00".
 * Se houver mais dígitos, formata como CNPJ no formato "00.000.000/0000-00".
 *
 * A função atualiza diretamente o valor do campo de input.
 *
 * @param {Event} e - Evento disparado pelo input.
 */
export function formatCpf_Cnpj(e) {
    const campo = e.target;
    const valor = campo.value.replace(/\D/g, ""); // Remove tudo o que não é dígito

    let novoValor = "";

    if (valor.length <= 11) {
        // CPF
        novoValor = valor.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4"
        );
    } else {
        // CNPJ
        novoValor = valor.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
            "$1.$2.$3/$4-$5"
        );
    }

    campo.value = novoValor;
}